module.exports = __webpack_public_path__ + "img/step1-b.db62f337.png";